module.exports = __webpack_public_path__ + "img/BRoyalGuard64_ua.15095e4c.webp";